module.exports = __webpack_public_path__ + "static/media/footer-layout-2.5d6f5b04.svg";